import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Building2, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!f.name || !f.email || f.password.length < 6) return toast.error("Enter your name, email and a password (min 6 chars)");
    setLoading(true);
    try { await register(f.name, f.email, f.password); nav("/"); }
    catch (err) { toast.error(err?.response?.data?.detail || "Registration failed"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-10 h-10 rounded-xl bg-indigo-600 flex items-center justify-center"><Building2 className="w-6 h-6 text-white" /></div>
          <div><div className="font-heading text-xl font-bold text-slate-900">RentLedger</div><div className="text-xs text-slate-500">Create your account</div></div>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div><label className="text-sm font-medium text-slate-700">Full Name</label><Input data-testid="reg-name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="Your name" /></div>
          <div><label className="text-sm font-medium text-slate-700">Email</label><Input data-testid="reg-email" type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} placeholder="you@company.com" /></div>
          <div><label className="text-sm font-medium text-slate-700">Password</label><Input data-testid="reg-password" type="password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} placeholder="At least 6 characters" /></div>
          <Button data-testid="register-submit" type="submit" disabled={loading} className="w-full bg-indigo-600 hover:bg-indigo-700">{loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Create account"}</Button>
        </form>
        <p className="text-sm text-slate-500 mt-6 text-center">Already have an account? <Link to="/login" className="text-indigo-600 font-medium">Sign in</Link></p>
      </div>
    </div>
  );
}
